import React, { useState, useEffect } from "react";
import SharedNumbersInfo from "./sharedSlideInfo";
import { motion, useScroll, useTransform } from "framer-motion";
import useWindowSize from "@hooks/useWindowSize";
import styles from "./style.module.scss";
const list = [
    {
        title: "Industry Expertise",
        tabName: "Research",
        slug: "research",
        description:
            "We tailor lead generation to your industry, whether that's legal, auto warranty, B2B, or B2C, designing campaigns around each sector's unique challenges.",
        img: "/severalbrands/assets/images/homePageConnectImg.jpg",
        bgColor: "#E6D4FF",
    },
    {
        title: "Legal",
        tabName: "Legal",
        slug: "legal",
        description:
            "Legal leads, especially in personal injury and motor vehicle accident cases, are some of the hardest to convert. People searching for legal help are often stressed, unfamiliar with the process, and wary of anything that feels like a sales pitch. We build content and campaigns that demystify what a legal claim actually involves, so the prospects who reach out are already informed and ready for a real conversation with your team.",
        img: "/severalbrands/assets/images/homePageLegalImg.jpg",
        bgColor: "#D4BBFF",
    },
    {
        title: "Auto Warranty",
        tabName: "Auto Warranty",
        slug: "auto-warranty",
        description:
            "Reaching the right car owners at the right time is tricky but essential. Through geo-targeted ads and behavior-driven strategies, we connect warranty providers with vehicle owners actively researching coverage, optimizing for quality over quantity in every campaign.",
        img: "/severalbrands/assets/images/homePageB2BImg.jpg",
        bgColor: "#C2A1FF",
    },
    {
        title: "B2B & B2C",
        tabName: "B2B & B2C",
        slug: "b2b-b2c",
        description:
            "Whether your leads are other businesses or individual consumers, what converts them is different. B2B leads respond best to lead scoring and LinkedIn-based targeting that keeps prospects engaged instead of sitting stagnant in a queue. B2C leads respond more to trust and immediacy, so we lean on review and comparison platforms, SEM, and social ads to move people from interest to purchase. Either way, campaigns are built around how your specific audience actually buys.",
        img: "/severalbrands/assets/images/homePageB2CImg2.jpg",
        bgColor: "#B081FF",
    },
];
const scaleFrom = 1;
const translateFrom = 800;
export default function B2BSlides() {
    const windowSize = useWindowSize();
    const [selectedEl, setSelectedEl] = useState("legal");
    const { scrollY } = useScroll();
    const [limit, setLimit] = useState(0);
    const scaleValue1 = useTransform(
        scrollY,
        [limit, limit + 1200],
        [scaleFrom, 0.97],
    );
    const scaleValue2 = useTransform(
        scrollY,
        [limit + 1200, limit + 2400],
        [scaleFrom, 0.98],
    );
    const scaleValue3 = useTransform(
        scrollY,
        [limit + 2400, limit + 3600],
        [scaleFrom, 0.99],
    );

    const yValue2 = useTransform(
        scrollY,
        [limit, limit + 1200],
        [translateFrom, windowSize.width > 2024 ? -610 : -460],
    );
    const yValue3 = useTransform(
        scrollY,
        [limit + 1200, limit + 2400],
        [translateFrom, windowSize.width > 2024 ? -1220 : -920],
    );
    const yValue4 = useTransform(
        scrollY,
        [limit + 2400, limit + 3600],
        [translateFrom, windowSize.width > 2024 ? -1830 : -1380],
    );

    const filteredList =
        windowSize.width < 1024
            ? [list.find((el) => el.slug === selectedEl)]
            : [...list];
    const finalList = filteredList.map((el, index) => {
        if (index === 0) {
            return {
                ...el,
                zIndex: 1,
                scaleValue: scaleValue1,
                yValue: 0,
            };
        }
        if (index === 1) {
            return {
                ...el,
                zIndex: 2,
                scaleValue: scaleValue2,
                yValue: yValue2,
            };
        }
        if (index === 2) {
            return {
                ...el,
                zIndex: 3,
                scaleValue: scaleValue3,
                yValue: yValue3,
            };
        }
        if (index === 3) {
            return {
                ...el,
                zIndex: 4,
                scaleValue: 1,
                yValue: yValue4,
            };
        }
    });

    const [hadFixedStyle, setFixedStyle] = useState(false);
    const [afterStyle, setAfterStyle] = useState(false);
    useEffect(() => {
        const limit =
            document
                .getElementById("mainScrollDivHomePage")!
                .getBoundingClientRect().top +
            window.scrollY +
            48;
        setLimit(limit);

        const handleScroll = () => {
            if (window.scrollY < limit + 3800 && window.scrollY > limit) {
                setFixedStyle(true);
            } else {
                setFixedStyle(false);
            }
            if (window.scrollY > 7000) {
                setAfterStyle(true);
            } else {
                setAfterStyle(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div id="mainScrollDivHomePage">
            <section
                className={`${
                    hadFixedStyle && windowSize.width > 1024
                        ? styles["fixed"]
                        : ""
                } ${styles["bgStyleBefore"]}    ${
                    afterStyle && windowSize.width > 1024
                        ? styles["bgStyleAfter"]
                        : ""
                }`}
            >
                <div
                    className={`${
                        hadFixedStyle && windowSize.width > 1024
                            ? "max-w-7xl 3xl:max-w-[120rem] mx-auto block px-4vw lg:px-4  "
                            : ""
                    } `}
                >
                    <h2 className="font-bold   text-3xl  leading-9 text-[#37367D] lg:hidden">
                        Industry Expertise
                    </h2>
                    <p className="mt-5 font-light lg:hidden mb-14">
                        We tailor lead generation to your industry, whether
                        that's legal, auto warranty, B2B, or B2C, designing
                        campaigns around each sector's unique challenges.
                    </p>
                    <div className="flex justify-center gap-4 sm:gap-10  lg:hidden">
                        {list
                            .filter((slide) => slide.slug !== "research")
                            .map((el) => (
                                <motion.button
                                    whileHover={{
                                        scale: [1, 1.2, 1],
                                        transition: {
                                            duration: 0.8,
                                            repeat: Infinity,
                                            delay: 0.3,
                                        },
                                    }}
                                    key={el.slug}
                                    className={`block text-[#6340A4] lg:text-lg lg:px-7 sm:px-4 px-2 lg:py-2 py-1 cursor-pointer  ${
                                        el.slug === selectedEl
                                            ? "border border-[#6340A4] rounded-3xl"
                                            : ""
                                    }`}
                                    onClick={() => {
                                        setSelectedEl(el.slug);
                                    }}
                                >
                                    {el.tabName}
                                </motion.button>
                            ))}
                    </div>
                    <ul className="mt-7 lg:mt-0    ">
                        {finalList?.map((el, index) => (
                            <SharedNumbersInfo key={index} info={el} />
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    );
}
